import { render, staticRenderFns } from "./TopicsIcon.vue?vue&type=template&id=9c2f669e&"
import script from "./TopicsIcon.vue?vue&type=script&lang=ts&"
export * from "./TopicsIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports